var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSingleFamilyRental({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    id: "svg2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.05 36.8064V37.0064H6.25H33.7494H33.75H33.95V36.8064V15.9612V15.874L33.8861 15.8146L20.1367 3.04875L20.0006 2.9224L19.8646 3.04874L6.11392 15.8146L6.05 15.874V15.9612V36.8064ZM32.6624 16.4869V35.6501H7.33697L7.33634 16.487L20 4.73053L32.6624 16.4869Z",
    fill: "#613ED2",
    stroke: "#613ED2",
    strokeWidth: 0.4,
    id: "path1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6885 21.5273L14.6885 36.8051M25.3827 21.5273L25.3827 36.8051M13.8867 22.3262H26.1445",
    stroke: "#613ED2",
    strokeWidth: 1.6,
    id: "path2"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000",
      strokeWidth: 0.0462428
    },
    d: "m 5.8513294,26.508671 0.00162,-10.693642 7.0528046,-6.5433527 c 3.879043,-3.5988439 7.072223,-6.5433526 7.095957,-6.5433526 0.02373,0 3.216274,2.9445087 7.094534,6.5433526 l 7.051382,6.5433527 0.0013,10.693642 0.0013,10.693641 H 20 5.849711 Z m 8.0446246,2 v -6.982659 h 6.127167 6.127168 v 6.982659 6.982658 h 3.16763 3.16763 l -4.8e-4,-9.468208 -4.8e-4,-9.468208 -6.226447,-5.780347 C 22.833597,7.5953757 20.018367,4.9942197 20.002077,4.9942197 c -0.01629,0 -2.832513,2.601156 -6.258272,5.7803463 l -6.2286532,5.780347 -3.505e-4,9.468208 -3.504e-4,9.468208 h 3.1907511 3.190752 z m 10.716931,0.774566 0.01173,-6.184971 h -4.578203 -4.578203 v 6.196757 6.196757 l 4.566474,-0.01179 4.566474,-0.01179 z",
    id: "path3"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSingleFamilyRental);
export default __webpack_public_path__ + "static/media/single-family-rental.d695cce5ec60ccb4a532a7a631395fae.svg";
export { ForwardRef as ReactComponent };